/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Archive } from "lucide-react";
import { Badge } from "../../../components/ui/badge";
import { FormatedDates } from "../../../services/helpers";

const ArchivedDetailsDialog = (props) => {
  const {
    selectedOrder,
    showDetailsModal,
    setShowDetailsModal,
    handleUnarchive,
  } = props;

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "1":
        return "High";
      case "2":
        return "Medium";
      case "3":
        return "Low";
      default:
        return "Unknown";
    }
  };

  const getPriorityBadgeVariant = (priority) => {
    switch (priority) {
      case "1":
        return "danger";
      case "2":
        return "warning";
      case "3":
        return "info";
      default:
        return "secondary";
    }
  };

  return (
    <Dialog open={showDetailsModal} onOpenChange={setShowDetailsModal}>
      <DialogContent className="sm:max-w-[600px] dark:bg-[#1A1F2C]">
        <div className="d-flex flex-center flex-space-between mb-28 mt-10">
        <div className="flex items-center gap-2 text-[#020817] dark:text-white" style={{fontSize:"18px", fontWeight:"600"}}>
          <Archive className="h-5 w-5" />
          Archived Order #{selectedOrder?.orderId}
        </div>
        <CloseIcon
            style={{ color: "red" }}
            fontSize="small"
            onClick={() => setShowDetailsModal(false)}
            />
            </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" style={{marginBottom:"18px"}}>
          <div>
            <h3 className="font-semibold mb-10 text-[#020817] dark:text-white">Order Information</h3>
            <div className="space-y-2">
              <div className="flex justify-between border-b pb-8">
                <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Order Date:</span>
                <span className="text-[#020817] dark:text-white" style={{fontSize:"16px"}}>{FormatedDates(selectedOrder?.dateOfRequest)}</span>
              </div>
              <div className="flex justify-between border-b pb-8">
                <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Client:</span>
                <span className="text-[#020817] dark:text-white"  style={{fontSize:"16px"}}>{selectedOrder?.clientName}</span>
              </div>
              <div className="flex justify-between border-b pb-8">
                <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Employee:</span>
                <span className="text-[#020817] dark:text-white" style={{fontSize:"16px"}}>{selectedOrder?.employeeName}</span>
              </div>
              <div className="flex justify-between pb-8">
                <span className="text-muted-foreground" style={{color:"#64748B", fontSize:"16px"}}>Priority:</span>
                <Badge variant={getPriorityBadgeVariant(selectedOrder?.priority)}>
                  {getPriorityLabel(selectedOrder?.priority)}
                </Badge>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-8 text-[#020817] dark:text-white">Supplies</h3>
            <div className="bg-slate-50 p-10 rounded-md dark:bg-[#1A1F2C]">
              <ul className="space-y-2">
                {selectedOrder?.supplyItems?.map((supply) => (
                  <li
                    key={supply?.id}
                    className="flex justify-between border-b last:border-0 pb-8"
                  >
                    <span className="text-[#020817] dark:text-white">{supply?.title}</span>
                    <span className="font-medium text-[#020817] dark:text-[#6B7280]">x{supply?.qty}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="space-y-3 mt-16">
          <h3 className="font-semibold text-[#020817] dark:text-white">Notes</h3>
          <div className="space-y-3 max-h-[150px] overflow-y-auto">
            {selectedOrder?.notes?.length === 0 ? (
              <p className="text-muted-foreground text-sm italic text-[#020817] dark:text-white">
                No notes for this order.
              </p>
            ) : (
              selectedOrder?.notes?.map((note, index) => (
                <div
                  key={index}
                  className="bg-slate-50 dark:bg-slate-800 p-3 rounded-md"
                >
                  <p className="text-[#020817] dark:text-white">{note}</p>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="flex justify-between mt-24">
          <Button
            variant="contained"
            style={{backgroundColor:"green", color:"white"}}
            onClick={() => handleUnarchive(selectedOrder)}
          >
            Restore Order
          </Button>
          <Button variant="outlined" className="text-[#020817] dark:text-white" onClick={() => setShowDetailsModal(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ArchivedDetailsDialog;
